<template>
  <div>
    <icon-badge
      v-if="hasOnlyOne"
      class="status__label"
      :iconColor="iconColor"
      :iconClass="iconClass"
      :badgeIconClass="badgeIconClass"
      :showBadge="showBadge"
      :badgeColor="badgeColor"
      :outlined="outlined"
      :showTooltip="showTooltip"
      :tooltipMessage="tooltipMessage"
    />
    <b-button
      v-else
      class="status__link"
      variant="link"
      @click="onClickLinkHandler()"
    >
      {{ label }}
    </b-button>
  </div>
</template>

<script>
import IconBadge from './IconBadge';

export default {
  components: {
    IconBadge,
  },
  props: {
    statusList: {
      type: Array,
      required: true,
    },
    customLabel: {
      type: String,
    },
    iconColor: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      required: true,
    },
    badgeIconClass: {
      type: String,
      default: '',
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
    badgeColor: {
      type: String,
      default: '',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    status() {
      const [status] = this.statusList;
      return status || false;
    },
    hasOnlyOne() {
      return (this.statusList || []).length === 1;
    },
    label() {
      return this.customLabel || this.$t('actions.details');
    },
  },
  methods: {
    onClickLinkHandler() {
      this.$emit('click-link');
    },
  },
};
</script>

<style lang="sass" scoped>
  .status
    &__link
      color: var(--color-info)
      text-decoration: underline
      cursor: pointer
      padding: 0
      &:hover
        color: var(--color-info)
</style>
